import React from "react";

import "../assets/css/style.css"
import "../assets/css/reset.css"
import "../assets/css/responsive-leyouts.css"
import {PhoneNumberInput} from "./PhoneNumberInput";
import {phoneNumberSelected, selectAmount} from "../state/action";
import {SelectAmount} from "./SelectAmount";
import {useState} from "../state/useState";

export function MobileData() {


    let [state, dispatch] = useState();

    return <>
        <PhoneNumberInput phoneNumber={state.phoneNumber}
                          onChange={(phoneNumber) => {
                              dispatch(phoneNumberSelected(phoneNumber))
                          }}/>
        <SelectAmount amounts={state.operatorAmounts}
                      onChange={(amount) => dispatch(selectAmount(amount))}/>
    </>
}